import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import { InputText } from "primereact/inputtext";
import { Editor } from "@tinymce/tinymce-react";
import EmailApi from "../../../Api/emailApi";
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb";
import "./viewEmailTemplate.scss";

const ViewEmailTemplate = () => {
    document.title = "View Email Template";
    const { id } = useParams();
    const [emailTemplate, setEmailTemplate] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const accessToken = localStorage.getItem("accessToken");
    const navigate = useNavigate();

    const getEmailTemplate = async () => {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            };
            const res = await EmailApi.getEmailTemplateById(id, config);
            setEmailTemplate(res.data);
        } catch (err) {
            setError(err.message || "Failed to fetch email template");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getEmailTemplate();
    }, [id, accessToken]);

    const breadcrumbItems = [
        { label: "Pixwik", link: "#" },
        { label: "Email Template", link: "#" },
        { label: "View Email Template", link: "#" },
    ];

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div className="main-content-container">
            <Row className="h-100">
                <Col xs="12" className="h-100 d-flex flex-column">
                    <div className="email-template-header d-flex align-items-center justify-content-between">
                        <CustomBreadCrumb data={breadcrumbItems} pageTitle="Email Template" />
                    </div>
                    <Card className="mt-4 flex-grow-1" >
                        <CardBody className="h-100">
                            <div className="email-template-view-form">
                                <div className="email-template-view-inp">
                                    <label htmlFor="title" className="label">
                                        Title
                                    </label>
                                    <InputText
                                        id="title"
                                        value={emailTemplate?.title || ""}
                                        className="inp-field-box"
                                        disabled
                                    />
                                </div>
                                <div className="email-template-view-inp">
                                    <label htmlFor="subject" className="label">
                                        Subject
                                    </label>
                                    <InputText
                                        id="subject"
                                        value={emailTemplate?.subject || ""}
                                        className="inp-field-box"
                                        disabled
                                    />
                                </div>
                                {/* <div className="email-template-view-inp">
                                    <label htmlFor="template" className="label">
                                        HTML Template
                                    </label>
                                    <div className="email-template-view-template">
                                        <div dangerouslySetInnerHTML={{ __html: emailTemplate?.template || "" }} />
                                    </div>
                                </div> */}
                                <div className="email-template-view-inp">
                                    <label htmlFor="template" className="label">
                                        HTML Template
                                    </label>
                                    <div className="email-template-view-template">
                                        <div dangerouslySetInnerHTML={{ __html: emailTemplate?.template || "" }} />
                                    </div>
                                </div>
                                
                                <div className="save-cancel-btn mt-4 d-flex align-items-center justify-content-start gap-3">
                                    <Button
                                        type="button"
                                        outline
                                        color="danger"
                                        className="waves-effect waves-light"
                                        onClick={() => navigate(-1)}
                                    >
                                        Back
                                    </Button>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default ViewEmailTemplate;